/**
 * Application Constants
 *
 * These values are hardcoded to avoid storing non-sensitive configuration
 * in AWS Secrets Manager. Only truly sensitive values (API keys, passwords,
 * tokens) should be in environment variables.
 */

// =============================================================================
// DEVELOPMENT DEFAULTS
// These are used automatically in development mode. In production, these must
// be provided via environment variables (AWS Secrets Manager).
// =============================================================================

// Local development database (not a secret - just local postgres with default creds)
// Used by Better Auth for session storage
// Schema selection is handled by `@@schema("core")` in prisma/schema.prisma
// (mirrors server), so no `?schema=` or libpq `options` needed in the URL.
export const DEV_DATABASE_URL =
	"postgresql://postgres:postgres@localhost:5432/event_manager";

// Development auth secret (not a secret - just for local dev auth)
// Must match the server's BETTER_AUTH_SECRET
export const DEV_BETTER_AUTH_SECRET =
	"dev-better-auth-secret-not-for-production";

// Development auth URL
export const DEV_BETTER_AUTH_URL = "https://localhost:3000";

// =============================================================================
// APPLICATION CONFIGURATION
// =============================================================================

// Application defaults
export const TIMEZONE = "America/New_York";
export const APP_NAME = "Calendar AI";
export const LOG_LEVEL = "info";

// AI provider configuration
export const OPENROUTER_BASE_URL = "https://openrouter.ai/api/v1";

// Default URLs (can be overridden by VITE_* build args)
export const DEFAULT_BACKEND_URL = "http://127.0.0.1:4000";
export const DEFAULT_APP_URL = "https://localhost:3000";

// Feature flags (hardcoded for production)
export const DEMO_MODE = false;
export const DISABLE_EVENT_DEBUG = true;
